module.exports = __webpack_public_path__ + "img/P2-zh.8ed49dd8.png";